module.exports = __webpack_public_path__ + "static/media/faq-accordion-add.a5d0a7ea.svg";